<template>
    <div class="chart">
      <apexchart type="pie" height="380" :options="chartOptions" :series="series"></apexchart>
    </div>
  </template>
  
  <script>
    import VueApexCharts from 'vue-apexcharts'
    export default {
      name: 'PersentaseLimbahSector',
      components: {
        apexchart: VueApexCharts,
      },
      data: function () {
        return {
          series: [60, 10,18,12],
          chartOptions: {
            chart: {
              width: 380,
              type: 'pie',
              events: {
                mounted: (chart) => {
                  chart.windowResizeHandler();
                }
              }
            },
            labels: ['Rumah  Tangga', 'UMK', 'Fasyankes', 'Pelaku Usaha'],
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          }
        }
      },
    }
  </script>